// const addGiftProductToCart = async (variantId, quantity) => { 
//   const url = '/cart/add.js';
//   const data = { id: variantId, quantity, sections: ['mini-cart'] };

//   try {
//     const response = await fetch(url, {
//       method: 'POST', 
//       headers: { 'Content-Type': 'application/json' },
//       body: JSON.stringify(data)
//     });

//     if (!response.ok) throw new Error('Network response was not ok ' + response.statusText);

//     const responseJson = await response.json();
//     console.log('Item added to cart:', responseJson);

//     // const cartResponse = await fetch(theme.routes.cart);
//     // const cartContent = await cartResponse.json();

//     // document.documentElement.dispatchEvent(new CustomEvent("cart:updated", {
//     //   bubbles: true,
//     //   detail: { cart: cartContent }
//     // }));

//     // const miniCartStatus = document.querySelector('#CartDrawer')?.getAttribute('drawer--is-open') === '';
    
//     // document.documentElement.dispatchEvent(new CustomEvent("cart:refresh", {
//     //   bubbles: true,
//     //   detail: { cart: cartContent, openMiniCart: miniCartStatus }
//     // }));

//     return true;
//   } catch (error) {
//     console.error('There was a problem with the fetch operation:', error);
//     return false;
//   }
// };

// const removeGiftProduct = async (variantId) => {
//   const url = '/cart/change.js';
//   const data = { id: variantId, quantity: 0 };

//   try {
//     const response = await fetch(url, {
//       method: 'POST',
//       headers: { 'Content-Type': 'application/json' },
//       body: JSON.stringify(data)
//     });

//     if (!response.ok) throw new Error('Network response was not ok ' + response.statusText);

//     const cart = await response.json();
//     console.log('Item removed from cart:', cart);
//     return true;
//   } catch (error) {
//     console.error('Error removing item from cart:', error);
//     return false;
//   }
// };

// function animateCounter(element, duration) {
//   const end = parseInt(element.dataset.value, 10);
//   const startTime = performance.now();

//   const updateCounter = (currentTime) => {
//     const progress = Math.min((currentTime - startTime) / duration, 1);
//     element.value = Math.floor(progress * end);
//     if (progress < 1) requestAnimationFrame(updateCounter);
//   };
//   requestAnimationFrame(updateCounter);
// }

// const checkFreeGifts = async () => {
//   const updateContainer = async (selector) => {
//     const container = document.querySelector(selector);
//     if (container) {
//       try {
//         const response = await fetch(window.location.href);
//         const html = await response.text();
//         const parser = new DOMParser();
//         const doc = parser.parseFromString(html, "text/html");
//         const newContent = doc.querySelector(selector);
//         if (newContent) container.innerHTML = newContent.innerHTML;
//       } catch (error) {
//         console.error(`Error updating ${selector}:`, error);
//       }
//     }
//   };

//   await Promise.all([
//     updateContainer(".drawer__contents--progress"),
//     updateContainer(".drawer__footer"),
//     updateContainer(".drawer__inner .cart__items")
//   ]);

//   const counterInput = document.getElementById("counterInput");
//   if (counterInput) animateCounter(counterInput, 800);

//   const freeGiftCircles = document.querySelectorAll('.rewardbar .rewardbar-freegift-circle');
//   const cartProductItems = document.querySelectorAll('.drawer__contents .cart__item .cart__item-name');
//   const activeCircle = Array.from(freeGiftCircles).find(circle => circle.classList.contains('active'));
//   const dataProductValues = Array.from(freeGiftCircles)
//     .map(circle => circle.getAttribute('data-product'))
//     .filter(Boolean);

//   if (activeCircle) {
//     const productData = activeCircle.getAttribute('data-product');
//     const matchingCartItem = Array.from(cartProductItems).find(item =>
//       item.getAttribute('data-variant') === productData
//     );

//     if (!matchingCartItem) {
//       console.log('Adding free gift:', productData);
//       const added = await addGiftProductToCart(productData, 1);
//       if (added && theme?.CartDrawer) {
//         new theme.CartDrawer().init();
//         typeof initRecommendedSlider === "function" && initRecommendedSlider();
//       }
//     } else {
//       console.log('Free gift already in cart:', productData);
//     }
//   } else {
//     const matchingCartItems = Array.from(cartProductItems).filter(item =>
//       dataProductValues.includes(item.getAttribute('data-variant'))
//     );

//     if (matchingCartItems.length > 0) {
//       for (const item of matchingCartItems) {
//         const variantId = item.getAttribute('data-variant');
//         await removeGiftProduct(variantId);
//       }

//       if (theme?.CartDrawer) {
//         new theme.CartDrawer().init();
//       }
//     } else {
//       console.log('No free gift to remove.');
//     }
//     typeof initRecommendedSlider === "function" && initRecommendedSlider();
//   }
// };
 



const FREE_GIFT_TRIGGER_COUNT = 3;
const FREE_GIFT_VARIANT_ID = document
  .querySelector(".rewardbar-freegift-circle")
  .getAttribute("data-product");

let isInternalUpdate = false;
let lastShouldHaveGift = null;

// Kurze Konfetti-Animation (Canvas, ohne externe Library).
// originEl = Element, aus dem das Konfetti "platzt" (z.B. Kreis der Progressbar).
let _confettiActive = false;
const cartConfetti = (originEl) => {
  if (_confettiActive) return;
  if (window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
  _confettiActive = true;

  const canvas = document.createElement("canvas");
  canvas.style.cssText =
    "position:fixed;inset:0;width:100vw;height:100vh;pointer-events:none;z-index:99999;";
  canvas.width = window.innerWidth;
  canvas.height = window.innerHeight;
  document.body.appendChild(canvas);
  const ctx = canvas.getContext("2d");

  let ox = window.innerWidth / 2;
  let oy = 140;
  if (originEl) {
    const r = originEl.getBoundingClientRect();
    if (r.width || r.height) {
      ox = r.left + r.width / 2;
      oy = r.top + r.height / 2;
    }
  }

  const colors = ["#0f9100", "#8CE14C", "#141414", "#FFD700", "#FF5252", "#4FC3F7"];
  const parts = Array.from({ length: 80 }, () => ({
    x: ox,
    y: oy,
    vx: (Math.random() - 0.5) * 10,
    vy: Math.random() * -9 - 4,
    size: Math.random() * 6 + 4,
    color: colors[Math.floor(Math.random() * colors.length)],
    rot: Math.random() * Math.PI * 2,
    vr: (Math.random() - 0.5) * 0.3,
  }));

  const dur = 100; // Frames (~1,6 s)
  let frame = 0;
  (function tick() {
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    const alpha = Math.max(0, 1 - frame / dur);
    parts.forEach((p) => {
      p.x += p.vx;
      p.y += p.vy;
      p.vy += 0.28;
      p.rot += p.vr;
      ctx.save();
      ctx.translate(p.x, p.y);
      ctx.rotate(p.rot);
      ctx.globalAlpha = alpha;
      ctx.fillStyle = p.color;
      ctx.fillRect(-p.size / 2, -p.size / 4, p.size, p.size / 2);
      ctx.restore();
    });
    if (++frame < dur) {
      requestAnimationFrame(tick);
    } else {
      canvas.remove();
      _confettiActive = false;
    }
  })();
};

// Reward-Bar Betrag formatieren (nutzt das Theme-Format, sonst Fallback "€X,XX")
const _formatRewardMoney = (cents) => {
  try {
    if (window.theme && theme.Currency && theme.settings) {
      return theme.Currency.formatMoney(cents, theme.settings.moneyFormat);
    }
  } catch (e) {}
  return "€" + (cents / 100).toFixed(2).replace(".", ",");
};

// Progressbar, Texte, Kreise und Versandkosten-Zeile DIREKT per JS aktualisieren.
// Kein Seiten-Refetch, kein HTML-Austausch -> der Warenkorb "lädt" nur einmal
// (buildCart rendert die Artikel), die Leiste füllt sich danach weich per Transition.
const updateRewardBar = (cart) => {
  const condition = document.querySelector(".condition_01");
  if (!condition) return;
  const bar = condition.querySelector(".progress-bar-container");
  if (!bar) return;

  const ship = parseInt(bar.getAttribute("data-ship"), 10) || 0;
  const gift = parseInt(bar.getAttribute("data-gift"), 10) || 0;
  const candy = 100;
  const total = cart.total_price;

  // Segmentierte Füllung: Versand-Stufe liegt bei 50 %
  let fill;
  if (ship > 0 && total <= ship) {
    fill = (total * 50) / ship;
  } else if (gift > ship) {
    fill = 50 + ((total - ship) * 50) / (gift - ship);
  } else {
    fill = 100;
  }
  fill = Math.max(0, Math.min(100, fill));

  const fillEl = bar.querySelector(".cartbar-fill");
  if (fillEl) fillEl.style.width = fill + "%";

  const candyCircle = bar.querySelector(".rewardbar-candy-circle");
  const shipCircle = bar.querySelector(".rewardbar-shipping-circle");
  const giftCircle = bar.querySelector(".rewardbar-freegift-circle");
  if (candyCircle) candyCircle.classList.toggle("active", total >= candy);
  if (shipCircle) shipCircle.classList.toggle("active", total >= ship);
  if (giftCircle) giftCircle.classList.toggle("active", total >= gift);

  // Konfetti beim Überschreiten von Stufe 2 (Versand) und Stufe 3 (Mystery Gift).
  // Nur beim Hochkreuzen der Schwelle, nicht beim ersten Laden der Seite.
  if (window._rewardLastTotal !== undefined && window._rewardLastTotal !== null) {
    const prev = window._rewardLastTotal;
    if (gift > 0 && prev < gift && total >= gift) {
      setTimeout(() => cartConfetti(giftCircle), 650);
    } else if (ship > 0 && prev < ship && total >= ship) {
      setTimeout(() => cartConfetti(shipCircle), 650);
    }
  }
  window._rewardLastTotal = total;

  const msg = condition.querySelector(".order-shipping p");
  if (msg) {
    if (!cart.item_count) {
      msg.innerHTML = "";
    } else if (total < ship) {
      msg.innerHTML =
        "Noch <span>" + _formatRewardMoney(ship - total) +
        "</span>, um <span>Gratis Lieferung</span> freizuschalten!";
    } else if (total < gift) {
      msg.innerHTML =
        "Noch <span>" + _formatRewardMoney(gift - total) +
        "</span>, um dein <span>MYSTERY GIFT</span> freizuschalten!";
    } else {
      msg.innerHTML =
        "<span>Stark!</span> Du hast Gratis Lieferung &amp; MYSTERY GIFT freigeschaltet 🎉";
    }
  }

  // Versandkosten "Kostenlos"-Zeile ein-/ausblenden
  document.querySelectorAll(".cart__item--versandkosten").forEach((el) => {
    el.style.display = total >= ship ? "" : "none";
  });
};

const _runFreeGiftsCheck = async () => {
  let cart;
  try {
    const res = await fetch("/cart.js");
    cart = await res.json();
  } catch (error) {
    console.error("Free gift error (cart fetch):", error);
    return;
  }

  // Leiste/Texte/Versandkosten ohne Seiten-Refetch aktualisieren
  updateRewardBar(cart);

  if (isInternalUpdate) return;

  try {
    const realCartItems = cart.items.filter(
      (item) => item.variant_id.toString() !== FREE_GIFT_VARIANT_ID
    );
    const giftItem = cart.items.find(
      (item) => item.variant_id.toString() === FREE_GIFT_VARIANT_ID
    );
    const qualifyingItem = realCartItems.find(
      (item) => item.quantity >= FREE_GIFT_TRIGGER_COUNT
    );

    const shouldHaveGift = Boolean(qualifyingItem);
    const hasGift = Boolean(giftItem);

    if (lastShouldHaveGift === null) {
      lastShouldHaveGift = shouldHaveGift;
      return;
    }

    if (shouldHaveGift === lastShouldHaveGift) return;

    isInternalUpdate = true;

    if (shouldHaveGift && !hasGift) {
      await fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id: FREE_GIFT_VARIANT_ID, quantity: 1 }),
      });
    }

    if (!shouldHaveGift && hasGift) {
      await fetch("/cart/change.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id: giftItem.key, quantity: 0 }),
      });
    }

    lastShouldHaveGift = shouldHaveGift;

    // Geschenk hat den Warenkorb serverseitig geändert -> bestehende Instanz
    // neu aufbauen lassen (KEINE neue CartDrawer-Instanz -> keine Doppel-Listener).
    document.dispatchEvent(new CustomEvent("cart:build"));
    typeof initRecommendedSlider === "function" && initRecommendedSlider();
  } catch (error) {
    console.error("Free gift error:", error);
  } finally {
    setTimeout(() => {
      isInternalUpdate = false;
    }, 400);
  }
};

// Debounce: bei einem Add wird der Cart mehrfach neu aufgebaut. Ohne Debounce
// würde die Progressbar mehrfach neu eingefügt und die Füll-Animation mehrfach
// abspielen. So läuft sie nur einmal.
let _freeGiftsDebounceTimer = null;
function checkFreeGifts() {
  clearTimeout(_freeGiftsDebounceTimer);
  _freeGiftsDebounceTimer = setTimeout(function () {
    _runFreeGiftsCheck();
  }, 150);
}

